import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchTeacherscheduledMeetings } from "../../../services/teacher";
import { reactToast } from "../../../helper";

export const getTeacherMeetings = createAsyncThunk(
  "data/getTeacherMeetings",
  async ({ teacherId, startDate, endDate }) => {
    try {
      const { status, data } = await fetchTeacherscheduledMeetings(
        teacherId,
        startDate,
        endDate
      );

      if (status === 200) {
        if (data?.data?.length) {
          return data?.data;
        } else {
          return [];
        }
      } else {
        reactToast("error", data?.message);
      }
    } catch (error) {
      console.log(error);
    }
  }
);
